import { Box, MenuItem, Select, Typography } from "@mui/material";
import Skeleton from "react-loading-skeleton";

const CustomDropDown = ({
  disabled,
  value,
  onChange,
  NoData,
  menuList,
  placeholder,
  sx = {},
  style = {},
  errors,
  Title,
  isLoading,
  getLabel,
  name
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "0px" }}>
      {Title && (
        <Typography
          sx={{
            color: "black",
            fontWeight: "400",
            textAlign: "left",
            fontFamily:'Outfit',
            fontSize: { xs: "14px", sm: "16px" },
            ...style,
            paddingBottom:'4px'
          }}
        >
          {Title}
        </Typography>
      )}
      {isLoading ? (
        <Skeleton height={"60px"} />
      ) : (
        <Select
          sx={{
            width: "100%",
            height: "56px",
           
            borderRadius: "10px",
            border:"1px solid rgba(0, 151, 178, 0.3)",
            background: "rgba(230, 245, 247, 1)",
            fontFamily:'Outfit',
            "&:focus": {
              outline: "none",
              boxShadow: "none",
            },
            "&:hover": {
              outline: "none",
            },
            ".MuiOutlinedInput-notchedOutline": {
            },
            ...sx,
          }}
          name={name}
          value={value === null ? "" : value}
          onChange={onChange}
          displayEmpty
          disabled={disabled}
        >
          <MenuItem style={{display:"none", fontFamily: 'Outfit', fontSize: "28px"}} value={""} disabled>
            {placeholder}
          </MenuItem>
          {menuList ? (
            menuList.map((elem, index) => (
              <MenuItem key={index} value={elem.id} sx={{
                fontFamily: "Outfit"
              }}>
                {getLabel ? elem?.name || elem?.full_name : elem?.name}
              </MenuItem>
            ))
          ) : (
            <Typography>{NoData}</Typography>
          )}
        </Select>
      )}
      {errors && (
        <Typography
          sx={{
            color: "red",
            fontWeight: "400",
            fontSize: { xs: "14px", sm: "14px" },
            marginTop: "5px",
          }}
        >
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default CustomDropDown;
